import React from 'react';

function CurrentDate() {
  const today = new Date();
  const day = today.getDate();
  const month = today.getMonth() + 1; // Les mois commencent à 0 en JavaScript
  const year = today.getFullYear();

  return (
    <div>
      {day} / {month} / {year}
    </div>
  );
}

export default CurrentDate;